import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog } from "primereact/dialog";
import Langs, { Localize } from "../../app/lang/langs";
import { Row } from "primereact/row";
import { Col } from "react-bootstrap";
import moment from "moment";
import { updateWeeklyReview } from "../../components/collabs/collabsSlice";
import { InputTextarea } from "primereact/inputtextarea";
import { Tag } from "primereact/tag";
import { getTagClass } from "../../app/utils/helpers";


export default function WeeklyFollowupModal(props) {

    const dispatch = useDispatch()
    const [updatedItem, setUpdatedItem] = useState(props.selected)
    const [errors, setErrors] = useState([])

    useEffect(() => {
        setUpdatedItem({
            ...props.selected
        })
    }, [props.selected])

    const handleSave = () => {
        let errors = []
        if (!updatedItem.comments) {
            errors.push("comments")
        }
        setErrors(errors)

        if (!errors.length) {
            dispatch(updateWeeklyReview({
                id: props.selected?.id,
                comments: updatedItem?.comments,
                id_collab: props.selected?.id_collab
            })).then(() => {
                props.onHide()
            })
        }
    }

    const handleChange = (e) => {
        setErrors([])
        let name = e.target.name
        let value = e.target.value
        setUpdatedItem((prev) => ({ ...prev, [name]: value }))
    }

    return (
        <Dialog
            header={`${Localize(props.selected?.type)} - ${props.selected?.prenom} ${props.selected?.nom} - ${Localize("Semaine")} ${parseInt(props.selected?.week) + 1}`}
            visible={props.selected}
            style={{ width: "50rem" }}
            onHide={props.onHide}
        >
            <div className="flex flex-column gap-4">
                <InputTextarea
                    className={"w-full mb-2 " + (errors.includes("comments") ? "error" : "")}
                    name={"comments"}
                    autoResize
                    value={updatedItem?.comments}
                    onChange={handleChange}
                    error={errors.includes("comments")}
                    disabled={true}
                />
                <Row className="d-flex justify-content-center align-items-center p-1 pb-2">
                    <Col md={5}>
                        <strong>
                            <Langs str="Status" />
                        </strong>
                    </Col>
                    <Col md={7}>
                        <Tag value={<Langs str={updatedItem?.status} />} severity={getTagClass(updatedItem?.status)} />
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-1 pb-2">
                    <Col md={5}>
                        <strong>
                            <Langs str="Suivi par" />
                        </strong>
                    </Col>
                    <Col md={7}>
                        <span>{props.selected?.createdBy}</span>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-1 pb-2">
                    <Col md={5}>
                        <strong>
                            <Langs str="updated_by" />
                        </strong>
                    </Col>
                    <Col md={7}>
                        <span>{props.selected?.updatedBy}</span>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center p-1 pb-2 mb-3">
                    <Col md={5}>
                        <strong>
                            <Langs str="updated_at" />
                        </strong>
                    </Col>
                    <Col md={7}>
                        <span>{props.selected?.updated_at && moment(props.selected?.updated_at).format("DD-MM-YYYY HH:mm")}</span>
                    </Col>
                </Row>
                {/*<DynamicButton
                    onClick={handleSave}
                    className='me-auto'
                    title={<Langs str="Save" />}
                    active={true}
                    color="green"
                />*/}
            </div>
        </Dialog>
    )
}